import axios from "~/plugins/axios";

export default {
  getById(emailId, includes) {
    return axios.get(`/web_api/v1/email/${emailId}`, { params: { includes } }).then((response) => response.data);
  },
  getBody(emailId) {
    return axios.get(`/web_api/v1/email/${emailId}/body`).then((response) => response.data);
  },
  updateEmail(emailId, data) {
    return axios.put(`/web_api/v1/email/${emailId}`, data).then((response) => response.data);
  },
  create(data) {
    return axios.post("/web_api/v1/email/create", data).then((response) => response.data);
  },
  replyOrForward(emailId, data) {
    return axios.post(`/web_api/v1/email/${emailId}/reply_or_forward`, data).then((response) => response.data);
  },
  processEmail(emailId) {
    return axios.put(`/web_api/v1/email/${emailId}/process`).then((response) => response.data);
  },
  processMultipleEmails(emailIds) {
    return axios.put("/web_api/v1/email/process", { emailIds }).then((response) => response.data);
  },
  unprocessEmail(emailId) {
    return axios.put(`/web_api/v1/email/${emailId}/unprocess`).then((response) => response.data);
  },
  unprocessMultipleEmails(emailIds) {
    return axios.put("/web_api/v1/email/unprocess", { emailIds }).then((response) => response.data);
  },
  matchEmail(emailId, data) {
    return axios.post(`/web_api/v1/email/${emailId}/match`, data).then((response) => response.data);
  },
  matchMultipleEmails(data) {
    return axios.post("/web_api/v1/email/multiple/match", data).then((response) => response.data);
  },
  unmatchEmail(emailId) {
    return axios.put(`/web_api/v1/email/${emailId}/unmatch`).then((response) => response.data);
  },
  unmatchMultipleEmails(emailIds) {
    return axios.put("/web_api/v1/email/unmatch", {
      emailIds,
    }).then((response) => response.data);
  },
  getByCustomersAndFilter(
    customerIds, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = "/web_api/v1/email/by_customers_and_filter";
    return axios.post(uri, {
      customer_ids: customerIds,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getByCustomerAndFilter(
    customerId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = "/web_api/v1/email/by_customer_and_filter";
    return axios.post(uri, {
      customer_id: customerId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedOverviewByUser(
    userId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/overview/${userId}`;
    return axios.post(uri, {
      user_id: userId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedOutgoingByUser(
    userId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/outgoing/${userId}`;
    return axios.post(uri, {
      user_id: userId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedOutgoingByEmailAccount(
    emailAccountId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/outgoing/emailaccount/${emailAccountId}`;
    return axios.post(uri, {
      email_account_id: emailAccountId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedProcessedByEmailAccount(
    emailAccountId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/processed/${emailAccountId}`;
    return axios.post(uri, {
      email_account_id: emailAccountId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedProcessedByMailbox(
    mailboxId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/processed/mailbox/${mailboxId}`;
    return axios.post(uri, {
      mailbox_id: mailboxId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedUnprocessedByEmailAccount(
    emailAccountId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/unprocessed/${emailAccountId}`;
    return axios.post(uri, {
      email_account_id: emailAccountId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getPaginatedUnprocessedByMailbox(
    mailboxId, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = `/web_api/v1/email/unprocessed/mailbox/${mailboxId}`;
    return axios.post(uri, {
      mailbox_id: mailboxId,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  countUnprocessedEmailsByEmailAccount(accountId) {
    return axios.get(`/web_api/v1/email/count/emailaccount/${accountId}`)
      .then((response) => response.data);
  },
  countUnprocessedEmailsByMailbox(mailboxId) {
    return axios.get(`/web_api/v1/email/count/mailbox/${mailboxId}`)
      .then((response) => response.data);
  },
  delete(emailId) {
    return axios.delete(`/web_api/v1/email/${emailId}`)
      .then((response) => response.data);
  },
};
